import { FirewallPolicyUiApi } from "~/api/FirewallPolicyUi";

export function useFirewallPolicyUiApi(): FirewallPolicyUiApi {
  const firewallPolicyUiApi = new FirewallPolicyUiApi(useHttpClient());

  return firewallPolicyUiApi;
}
